import { keyframes } from '@emotion/react';
import { Box, styled } from '@mui/material';

import type { Theme } from '@mui/material';
import type { ButtonConfig } from '@shared/ui/containers/SwiperContainerWithButtons/SwiperContainerWithButtons';

const buttonsSize = (size: any, theme: Theme) => {
  const sizeButtons: { [key: string]: Object } = {
    large: {
      width: '40px',
      height: '40px',
      svg: {
        height: '24px',
        width: '24px',
        path: {
          fill: theme.palette.case.neutral.n500,
        },
      },
    },
    medium: {
      width: '24px',
      height: '24px',
      svg: {
        height: '16px',
        width: '16px',
        path: {
          fill: theme.palette.case.neutral.n500,
        },
      },
    },
  };

  return sizeButtons[size || 'large'];
};

export const SwiperContainer = styled('div')`
  overflow: hidden;
  display: flex;
  position: relative;
  .swiper {
    margin-left: 0;
    margin-right: 0;
  }
  .swiper-android .swiper-slide,
  .swiper-wrapper {
    box-sizing: border-box;
  }
  .swiper-button-next.swiper-button-disabled,
  .swiper-button-prev.swiper-button-disabled {
    display: none;
  }
  .swiper-slide {
    width: auto;
    flex-shrink: 0;
  }
  @media (max-width: 600px) {
    .swiper-slide {
      width: 100%;
      flex-shrink: 0;
    }
    .swiper {
      width: 100%;
    }
  }
`;

const press = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(0.8); }
    100% { transform: scale(1); }
  `;

type RightSlidePropsType = {
  isFirstSlided?: boolean;
  sliderArrowStyle?: number;
  isClicked?: boolean;
  rightConfig?: ButtonConfig;
  size?: any;
};
export const SwiperNextButton = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['isFirstSlided', 'sliderArrowStyle', 'isClicked', 'rightConfig', 'size'].includes(prop),
})<RightSlidePropsType>(({ theme, isFirstSlided, isClicked, rightConfig, size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '20px',
  background: theme.palette.case.neutral.n0,
  border: `1px solid ${theme.palette.case.neutral.n200}`,
  transition: '0.3s all',
  position: 'absolute',
  zIndex: 5,
  top: 'calc(50% - 20px)',
  right: '12px',
  boxShadow: theme.palette.case.shadow.default,
  cursor: 'pointer',
  opacity: isFirstSlided ? 0 : 1,
  userSelect: 'none',

  '&:hover': {
    background: theme.palette.case.neutral.n100,
  },
  ...(size && {
    ...buttonsSize(size, theme),
  }),
  ...(isClicked && {
    animation: `${press} 0.3s ease`,
  }),
  ...(rightConfig && {
    ...rightConfig,
  }),
  [theme.breakpoints.down('sm')]: {
    right: '12px',
    top: '80px',
    width: '24px',
    height: '24px',
    svg: {
      height: '16px',
      width: '16px',
    },
    '&:hover': {
      background: theme.palette.case.neutral.n0,
    },
  },
}));

type LeftSlidePropsType = {
  isLastSlided?: boolean;
  sliderArrowStyle?: number;
  isClicked?: boolean;
  leftConfig?: ButtonConfig;
  size?: any;
};

export const SwiperPrevButton = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['isLastSlided', 'sliderArrowStyle', 'isClicked', 'leftConfig', 'size'].includes(prop),
})<LeftSlidePropsType>(({ theme, isLastSlided, isClicked, leftConfig, size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none',
  borderRadius: '20px',
  top: 'calc(50% - 20px)',
  background: theme.palette.case.neutral.n0,
  border: `1px solid ${theme.palette.case.neutral.n200}`,
  transition: '0.3s all',
  position: 'absolute',
  zIndex: 5,
  left: '12px',
  opacity: isLastSlided ? 0 : 1,
  boxShadow: theme.palette.case.shadow.default,
  cursor: 'pointer',
  '&:hover': {
    background: theme.palette.case.neutral.n100,
  },
  ...(isClicked && {
    animation: `${press} 0.4s ease`,
  }),
  ...(leftConfig && {
    ...leftConfig,
  }),

  ...(size && {
    ...buttonsSize(size, theme),
  }),
  [theme.breakpoints.down('sm')]: {
    left: '12px',
    width: '24px',
    height: '24px',
    top: '80px',
    svg: {
      height: '16px',
      width: '16px',
    },
    '&:hover': {
      background: theme.palette.case.neutral.n0,
    },
  },
}));
